module.exports = __webpack_public_path__ + "img/flag-br.ef4d04bd.svg";